import Vue from 'vue'
import Router from 'vue-router'

//::: error pages::::
import SystemError from '../pages/errors/System.vue'
import Noaccess from '../pages/errors/Noaccess.vue'

import Login from '../pages/Login.vue'
import Top from '../pages/Top.vue'

// Notice pages
import AdminNoticeTop from '../pages/admin/Notice/Top.vue'
import New from '../pages/admin/Notice/New.vue'
import Confirmation from '../pages/admin/Notice/Confirmation.vue'
// Logs pages
import LogsTop from '../pages/admin/Logs/Top.vue'
import LogsList from '../pages/admin/Logs/List.vue'
import LogsDetails from '../pages/admin/Logs/Details.vue'

//Settings
import SettingsTop from '../pages/admin/Settings/Top.vue'
import SettingsMenu from '../pages/admin/Settings/Menu.vue'
import SettingsUser from '../pages/admin/Settings/User.vue'
import SettingsGroup from '../pages/admin/Settings/Group.vue'
import SettingsCategory from '../pages/admin/Settings/Category.vue'

//乗務員ページ
import Driver from '../pages/notice/Driver.vue'
import Details from '../pages/notice/Details.vue'

import store from '../store'

Vue.use(Router)

const routes = [
  { path: '/',          name: 'Top',      component: Top,         meta: { requiresAuth: true }, },
  { path: '/login',     name: 'login',    component: Login                                      },
  { path: '/500',       name: '500',      component: SystemError,                               },
  { path: '/noaccess',  name: 'noaccess', component: Noaccess,                                  },
  // ここから乗務員ページ
  { path: '/driver/:group' ,              name: 'driver',    component: Driver,       meta: { requiresAuth: true }, },
  { path: '/news/ditals/:group/:news' ,   name: 'details',   component: Details,      meta: { requiresAuth: true }, },

  // ここからAdminページ
  {
    path: '/notice',
    component: AdminNoticeTop,
    meta: { requiresAuth: true, requiresSuper_user: true },
    children: [
      {
        path: 'new',
        name: 'New',
        component: New,
      },
      {
        path: 'confirmation',
        name: 'Confirmation',
        component: Confirmation,
      },
    ]
  },
  {
    path: '/settings',
    component: SettingsTop,
    meta: { requiresAuth: true, requiresSuper_user: true},
    children: [
      {
        path: 'menu',
        name: 'SettingsMenu',
        component: SettingsMenu,
      },
      {
        path: 'user',
        name: 'SettingsUser',
        component: SettingsUser,
      },
      {
        path: 'group',
        name: 'SettingsGroup',
        component: SettingsGroup,
      },
      {
        path: 'category/:group_id',
        name: 'SettingsCategory',
        component: SettingsCategory,
      }
    ]
  },
  {
    path: '/logs',
    component: LogsTop,
    meta: { requiresAuth: true, requiresSuper_user: true},
    children: [
      {
        path: 'list',
        name: 'LogsList',
        component: LogsList,
      },
      {
        path: 'details/:news',
        name: 'LogsDetails',
        component: LogsDetails,
      },
    ]
  }
]

const router = new Router({
  // mode: 'history',
  routes
})

router.beforeEach(function(to, from, next) {
  // 次の行き先のルートオブジェクトにメタフィールドがあるかどうかチェックする
  if(to.matched.some( record => record.meta.requiresAuth)) {
    //ユーザー情報があるかどうか
    if(store.getters['auth/check']){
      //管理者としてアクセスする場合
      if(to.matched.some( record => record.meta.requiresSuper_user)) {
        //super_user権限があるかどうか
        if(!store.getters['auth/super_user']) {
          router.replace('/')
          next({ path: '/noaccess' })
        }
        next()
      }
      next()
    }else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }else{
    next()
  }
})

export default router